import React from "react";
import PropTypes from "prop-types";
import { DownloadButton } from "components/buttons";

const  createTxtFromResponse = ( data, filename) => {
    const archivo = new Blob([data], { type: 'text/plain' });
    const url = URL.createObjectURL(archivo);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${filename}.txt`;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const DownloadTxtButton = ({ data, filename }) => <DownloadButton onClick={() => createTxtFromResponse( data, filename )} />;

DownloadTxtButton.propTypes = {
  /**
   * Objeto de datos que será exportado como JSON.
   */
  data: PropTypes.string.isRequired,

  /**
   * Nombre del fichero de descarga.
   */
  filename: PropTypes.string.isRequired,
};

export default DownloadTxtButton;